import {
  ChangeDetectionStrategy,
  Component,
  Input,
  TemplateRef,
} from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

type ConfirmationComponentType = string | TemplateRef<unknown>;

@Component({
  selector: 'atx-confirmation',
  templateUrl: './confirmation.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class ConfirmationModalComponent {
  @Input()
  public message: ConfirmationComponentType;

  @Input()
  public title?: string;

  @Input()
  public showCloseBtn = false;

  @Input()
  public hideFooter = false;

  @Input()
  public isUseDeleteConfirmButton: boolean;

  @Input()
  public showCancelButton = true;

  @Input()
  public confirmButtonText?: string;

  constructor(public modal: NgbActiveModal) {}

  get confirmButtonLabel() {
    return (
      this.confirmButtonText ??
      (this.isUseDeleteConfirmButton
        ? $localize`:UI|Delete Confirm Button Label@@deleteConfirmButtonLabel:Yes, Delete`
        : $localize`:UI|Default Confirm Button Label@@defaultConfirmButtonLabel:Confirm`)
    );
  }

  public isTemplate(item: ConfirmationComponentType) {
    return item instanceof TemplateRef;
  }

  public isMessage(item: ConfirmationComponentType) {
    return typeof item === 'string';
  }
}
